export default "__VITE_ASSET__CELSKNJA__"